export default __webpack_public_path__ + "static/media/S-030.e50d884c.png";